import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Notifications } from 'src/components/Notifications';
import { ROUTE } from 'src/constants/routes';
import { AppHooks } from 'src/containers/AppHooks';
import { AppNavbar } from 'src/containers/AppNavbar';
import { SignInDialog } from 'src/containers/ConnectionMenu/SignInDialog';
import { CreateProjectDialog } from 'src/containers/CreateProjectDialog/CreateProjectDialog';
import { Home } from 'src/containers/Home/Home';
import { Project } from 'src/containers/Project/Project';
import { ProjectOverlays } from 'src/containers/Project/ProjectOverlays';
import { ProjectDiagramContextProvider } from 'src/containers/ProjectDiagram/ProjectDiagramContextProvider';
import { ProjectFileUploadPreviewDialog } from 'src/containers/ProjectFileUploadPreviewDialog/ProjectFileUploadPreviewDialog';
import { ProjectMapping } from 'src/containers/ProjectMapping/ProjectMapping';
import { ProjectModelDialog } from 'src/containers/ProjectModelDialog/ProjectModelDialog';
import { ProjectVirtualGraphPreviewDialog } from 'src/containers/ProjectVirtualGraphPreviewDialog/ProjectVirtualGraphPreviewDialog';
import { PublishProjectDrawer } from 'src/containers/PublishProjectDrawer/PublishProjectDrawer';
import { VoiceboxDialog } from 'src/containers/Voicebox/VoiceboxDialog';

export const App: React.VFC = () => {
  return (
    <>
      <AppHooks />
      <AppNavbar />
      <Switch>
        <Route exact path={ROUTE.HOME}>
          <Home />
        </Route>
        <Route path={ROUTE.PROJECT}>
          <ProjectDiagramContextProvider>
            <Route exact path={ROUTE.PROJECT}>
              <Project />
            </Route>
            <Route exact path={ROUTE.PROJECT_MAPPING}>
              <ProjectMapping />
            </Route>
            <ProjectOverlays />
          </ProjectDiagramContextProvider>
        </Route>
        <Redirect to={ROUTE.HOME} />
      </Switch>
      {
        // eslint-disable-next-line jsdoc/check-alignment
        /**
         * All containers that utilize a Blueprint portal should be rendered here.
         * The order of the following components matters. The elements will render
         * in increasing order, so Notifications are last and will be at the top.
         *
         * Blueprint will mount a portal div to contain the contents. You should
         * not wrap these elements within a route because then the portal div will
         * unmount and remount as the top-most, and disrupt the defined z-order.
         *
         * If you need to render a dialog/drawer that needs routing information,
         * you should wrap the contents of that dialog/drawer in a route.
         */
      }
      <CreateProjectDialog />
      <PublishProjectDrawer />
      <ProjectModelDialog />
      <VoiceboxDialog />
      <ProjectFileUploadPreviewDialog />
      <ProjectVirtualGraphPreviewDialog />
      <SignInDialog />
      <Notifications />
    </>
  );
};
